class LocationSelector {
  constructor(
    $scope,
    $q,
    LogService,
    GeoService,
    VenueService,
    StaffUserService,
    geolocation,
    translateFilter,
    moment
  ) {
    "ngInject";
    this.$scope            = $scope;
    this.$q                = $q;
    this.LogService        = LogService;
    this.GeoService        = GeoService;
    this.VenueService      = VenueService;
    this.StaffUserService  = StaffUserService;
    this.geolocation       = geolocation;
    this.translateFilter   = translateFilter;
    this.moment            = moment;

    this._errors           = [];
    this._location         = null;
    this._GPSStatusMessage = false;
    this._placesLoading    = false;
    this._executionTeamPlacesLoading = false;

    this.accordions        = {
      locationSearch: true,
      locationSearchSelection: false
    };



    this.lat  = false;
    this.lng = false;

    this._eventDatePickerOptions = {minDate: null, maxDate:null};

    this.start_time = new Date().setHours(9,0,0);
    this.end_time = new Date().setHours(17,0,0);
    this.venueSearch = {};
    this.venueSearch.nearbyOnly = true; // Default state when searching for venues
  }

  $onInit() {
    this.GPSStatusMessage = "GETTING_GPS_LOCATION";
    this.geolocation.getLocation().then((data) => {
      this.lat = data.coords.latitude;
      this.lng = data.coords.longitude;
      this.GeoService.latLngLookup(this.lat + ',' + this.lng)
        .then((response) => {
          this.GPSStatusMessage = false;
          this._location = response.data.results[0].formatted_address;
        });
    })
      .catch(() => {
        this.GPSStatusMessage = "GPS_LOCATION_FAILED";
      });
  }

  // From bindings
  set staffUser(staffUser) {
    this._staffUser = staffUser;
  }
  get staffUser() {
    return this._staffUser;
  }
  set program(program) {
    this._program = program;
  }
  get program() {
    return this._program;
  }
  set selectedSearchVenue(obj) {
    this._selectedSearchVenue = obj;
  }
  get selectedSearchVenue() {
    return this._selectedSearchVenue;
  }
  set eventType(obj) {
    this._eventType = obj;
  }
  get eventType() {
    return this._eventType;
  }

  // Program selector may define client ID or it may be passed directly as clientsId
  get clients_id() {
    if (this.clientsId) {
      return this.clientsId;
    }
    if (this.program.clients_id) {
      return this.program.clients_id;
    }
    return false;
  }

  get location() {
    return this._location;
  }

  set eventDatePickerOpened(opened) {
    this._eventDatePickerOpened = opened;
  }

  get placesLoading() {
    return this._placesLoading;
  }

  set placesLoading( val ) {
    this._placesLoading = val;
  }

  get executionTeamPlacesLoading() {
    return this._executionTeamPlacesLoading;
  }

  set executionTeamPlacesLoading( val ) {
    this._executionTeamPlacesLoading = val;
  }


  get eventDatePickerOpened() {
    return this._eventDatePickerOpened;
  }

  set eventDatePickerOptions(val) {
    this._eventDatePickerOptions = val;
  }
  get eventDatePickerOptions() {
    return this._eventDatePickerOptions;
  }

  set GPSStatusMessage(message) {
    if (!message) {
      this._GPSStatusMessage = '';
    } else {
      this._GPSStatusMessage = this.translateFilter(message);
    }

  }
  get GPSStatusMessage() {
    return this._GPSStatusMessage;
  }

  /**
   * Gets the name of the first active tab.  There are a bunch of toggles that determine what displays and the first
   * visible one should be active
   * @returns string Name of active tab
   */
  get firstActiveTabName() {
    // MJOL-2887 Only default to 'My Locations' if staff user does have locations
    const staffUserHasVenues = this.staffUserSearchVenueOptions().length > 0;

    if (staffUserHasVenues && !!this.program.staff_can_select_from_my_locations) {
      return 'My Locations';
    } else if (!!this.program.staff_can_search_locations) {
      return 'Search';
    } else if (this.eventType && !!this.program.staff_can_search_nearby_locations) {
      return 'Nearby';
    } else if (!!this.program.staff_can_select_from_my_territory) {
      return 'My Territory';
    } else if (!!this.program.staff_can_create_locations) {
      return 'New';
    }

  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  staffUserSearchVenueOptions() {
    const allVenues = this.staffUser && this.staffUser.venues || [];
    return allVenues.filter(venue => parseInt(venue.clients_id) === parseInt(this.clients_id));
  }

  getExecutionTeamVenues() {
    this.executionTeamPlacesLoading = true;
    this.VenueService.getExecutionTeamVenues(this.program.id, this.program.clients_id )
      .then((response) => {
        this.executionTeamVenues = response.data.venues;
        this.executionTeamPlacesLoading = false;
      }).
    catch(() => {
      this.LogService.log("No lookup - GPS failed");
    });
  }

  placesLookup() {
    // If the event type changes the available google places types may also change and must reload
    if (!this.eventTypeWatcherExists) {
      this.$scope.$watch(
        () => {
          return this.eventType;
        },
        () => {
          this.doPlacesLookup();
        }
      );
      this.eventTypeWatcherExists = true;
    }

    this.geolocation.getLocation().then((data) => {
      if (data.coords.latitude !== this.lat || data.coords.longitude !== this.lng) {
        this.lat = data.coords.latitude;
        this.lng = data.coords.longitude;
        this.doPlacesLookup();
      }
    });

  }

  doPlacesLookup() {
    // No lat and lng?  Watch for those to become available.
    if (!(this.lat === this.lng) && !this.coordinatesWatcherExists) {
      this.LogService.warn("Undefined latitude and logitude - location lookup aborted: " + this.lat + "," + this.lng);
      this.$scope.$watch(
        () => {
          return this.lat && this.lng;
        },
        () => {
          this.doPlacesLookup();
        }
      );
      this.coordinatesWatcherExists = true;
      return;
    }

    if (this.placesLoading > 0 || !this.lat || !this.lng) {
      return;
    }

    this.placesList = false;
    // Google places are opt-in per client; otherwise staff create events at places outside the system.
    const googlePlacesEnabled = this.googlePlacesEnabled();
    this.placesLoading = googlePlacesEnabled ? 2 : 1;

    if (googlePlacesEnabled) {
      this.GeoService.placeSearch( this.lat + ',' + this.lng, this.eventType.google_place_types, this.staffUser.profile.units)
        .then((response) => {
          this.placesList = response.data;
          this.placesLoading -= 1;
          // Set the search result coordinates flag with current location. This prevents
          // reloading from Places result when selecting the tab if result exists.
          this._coordinatesOfPlaceSearchResult = (this.lat + ',' + this.lng);
        })
        .catch(() => {
          this.LogService.log("No lookup - GPS failed");
        });
    }

    this.VenueService.nearbyVenueSearch(this.lat + ',' + this.lng, this.clients_id, 0.5)
      .then((response) => {
        this.nearbyPlacesList = response.data;
        this.placesLoading -= 1;
      }).
    catch(() => {
      this.LogService.log("No lookup - GPS failed");
    });
  }

  // Search for venues from the search input fields
  doVenueSearch() {
    const params = {
      street_address1: this.venueSearch.street_address1,
      venue_name: this.venueSearch.venue_name,
      state: this.venueSearch.state,
      city: this.venueSearch.city,
      zip: this.venueSearch.zip,
      lat: this.lat,
      lng: this.lng,
      nearby: this.venueSearch.nearbyOnly,
      clients_id: this.clients_id
    };

    this.VenueService.venueSearch(params, {disableCache: true})
      .then((response) => {
        this.venueSearchResults = response.data.venues;
        this.accordions.locationSearch = false;
      })
      .catch(() => {});
  }

  // Selecting a google place result triggers a lookup on the place id.
  selectGooglePlaceResult(value) {
    // If the user clicked on a place result that was already in the nearby venues list
    // pulled from the database that's what they should be seeing
    let venueFromNearbyList = this.nearbyPlacesList.venues.find((el) => {
      return parseInt(el.place_id) === parseInt(value.place_id);
    });
    if (!!venueFromNearbyList) {
      this.selectedSearchVenue = venueFromNearbyList;
      return;
    }

    // Google Place results don't have full info, the API has to be queried for details
    this.GeoService.placeDetail(value.place_id)
      .then((response) => {
        const place = response.data.result;

        // Response fields are not consistently organized, so we have to search for the components
        let street_number = place.address_components.find((val) => {
          return (val.types.indexOf('street_number') > -1);
        });
        let street = place.address_components.find((val) => {
          return (val.types.indexOf('route') > -1);
        });
        let city = place.address_components.find((val) => {
          return (val.types.indexOf('locality') > -1);
        });
        let state = place.address_components.find((val) => {
          return (val.types.indexOf('administrative_area_level_1') > -1);
        });
        let zip = place.address_components.find((val) => {
          return (val.types.indexOf('postal_code') > -1);
        });

        let street_address1 = '';
        if (street_number) {
          street_address1 += street_number.short_name + " ";
        }
        if (street) {
          street_address1 += street.short_name;
        }

        this.selectedSearchVenue = {
          venue_name: place.name,
          street_address1: street_address1,
          city: city.long_name,
          state: state.short_name,
          zip: zip.short_name,
          place_id: value.place_id
        }
      });
  }

  selectSearchVenue(value) {
    this.selectedSearchVenue = value;
  }
  selectYourLocationResult(value) {
    this.selectedSearchVenue = value;
  }

  cancelVenueSelection() {
    this.$scope.$emit('cancelLocationSelect');
    this.selectedSearchVenue = false;
  }

  getVenueTypesForProgram() {
    if (!this.clients_id && !this.program) {
      return [];
    }

    const clientId = this.clients_id;
    const client = this.staffUser.clients.find((el) => parseInt(el.id) === parseInt(clientId));
    return client.venue_types;
  }

  /**
   * Whether the client allows Google places in the nearby search
   * @returns boolean
   */
  googlePlacesEnabled() {
    const clientId = this.clients_id;
    const client = this.staffUser.clients.find((el) => parseInt(el.id) === parseInt(clientId));
    return !!(client && client.staff_can_search_nearby_google_places);
  }

  getMarketsForProgram() {
    if (!this.clients_id && !this.program) {
      return [];
    }

    const clientId = this.clients_id;
    const client = this.staffUser.clients.find((el) => parseInt(el.id) === parseInt(clientId));
    return client.markets;
  }

  /**
   * Check if this is visible
   * @param section
   * @returns boolean
   */
  canDisplaySection(section) {
    switch (section) {
      case 'add address':
        return (
          this.venue
          && this.venue.venue_name
          && this.venue.street_address1
          && this.venue.city
          && this.venue.state
          && this.venue.venues_types_id
          && this.venue.markets_id
        );
    }
  }

  // Takes the address entered in the 'new address' tab and sets it as the selected venue
  addAddress() {
    this.selectedSearchVenue = this.venue;

    const venueTypes = this.getVenueTypesForProgram();
    const venueType = venueTypes.find((val) => {
      return parseInt(val.id) === parseInt(this.venue.venues_types_id);
    });
    this.selectedSearchVenue.venues_types_name = venueType.name;

    const markets = this.getMarketsForProgram();
    const market = markets.find((val) => {
      return parseInt(val.id) === parseInt(this.venue.markets_id);
    });
    this.selectedSearchVenue.markets_name = market.name;
  }
}

export default LocationSelector;

